/* eslint-disable @typescript-eslint/no-explicit-any */
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

import store from "@/store/index";

import Login from "@/modules/login/login.vue";
import Main from "@/modules/main/main.vue";
import Credentials from "@/pages/credentials/credentials.vue";
import Reclassify from "@/pages/reclassify/reclassify.vue";
import Upload from "@/pages/upload/upload.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      requiresUnauth: true,
    },
  },
  {
    path: "/",
    name: "Main",
    component: Main,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        name: "Upload",
        component: Upload,
        meta: {
          requiresAuth: true,
          authorizationGroup: ["MASTER", "USER_UPLOAD"],
        },
      },
      {
        path: "/credentials",
        name: "Credentials",
        component: Credentials,
        meta: {
          requiresAuth: true,
          authorizationGroup: ["MASTER"],
        },
      },
      {
        path: "/reclassify",
        name: "Reclassify",
        component: Reclassify,
        meta: {
          requiresAuth: false,
          authorizationGroup: ["MASTER", "USER_RECLASSIFY"],
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory("/#/"),
  routes,
});

router.beforeEach((to: any, from: any, next) => {
  const expiresIn = store.getters["auth/expiresIn"] || 0;

  if (to.path !== "/login" && to.meta.requiresAuth && expiresIn * 1000 < Date.now()) {
    store.dispatch("auth/logout");
  } else {
    const type = store.getters["auth/type"];

    if (to.meta.authorizationGroup?.length && !to.meta.authorizationGroup.includes(type)) {
      store.dispatch("auth/logout");
    } else {
      next();
    }
  }
});

export default router;
